module.exports = global["$"] = require("-!/home/runner/work/shared-interest/shared-interest/node_modules/expose-loader/index.js?jQuery!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js-exposed
// module id = 0
// module chunks = 0